import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Liberty from "@/pages/Liberty";

export const Route = createFileRoute("/by/liberty")({
  head: () => routeHead('AGAPE Liberty — Кантэнт і бачнасць у AI', META_DESCRIPTIONS.liberty.by, '/by/liberty'),
  component: Liberty,
});
